import { useSearchParams } from 'react-router-dom';
import { ContentPanel } from '@/components/layouts';

/**
 * 選單到得了、但盤點結果裡沒有對應頁面的功能。
 *
 * 目前只有一個：`instruction/personalizationGPA/showVersion`（表單精靈／個人化等第制成績設定）。
 * 原因是 analysis 索引掃的是 src/ePortfolio，而該功能只存在於基準樹
 * （見 MODULE-FUNCTION-INVENTORY.md §3.5）。
 *
 * ponytail: 刻意做成一個會說明原因的頁面，而不是靜默 404 或從選單裡拿掉——
 * 拿掉會讓雛形的選單與原系統對不起來，靜默 404 則會讓人以為是壞掉。
 */
export function NotImplementedPage() {
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from');

  return (
    <ContentPanel uiId="not-implemented-panel" title="此功能尚未建立頁面">
      <p data-ui-id="not-implemented-reason">
        這個功能在原系統選單中存在，但目前的盤點結果（Gate 1 候選清單）裡沒有對應的可路由頁面，
        因此雛形尚未建立畫面。
      </p>
      {from === null ? null : (
        <p data-ui-id="not-implemented-source">
          原系統路徑：<code>{from}</code>
        </p>
      )}
      <p data-ui-id="not-implemented-next">
        要補上這一頁，必須先由 S2-3 在原系統實際觸達確認，不能只憑原始碼推定。
      </p>
    </ContentPanel>
  );
}
